/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Keys constants
 */

export enum Keys {
  TAB = 9,
  ENTER = 13,
  ESC = 27,
  SPACE = 32,
  ARROW_LEFT = 37,
  ARROW_UP = 38,
  ARROW_RIGHT = 39,
  ARROW_DOWN = 40,
  LOWER_Z = 122,
  UPPER_A = 65,
}
